<template>
    <div class="stay__map"></div>
</template>
<script>
    export default {
        props: {
            pins: Array
        },
        data() {
            return {
                map: null,
                infoWindow: null,
                mapPins: []
            }
        },
        watch: {
            pins() {
                this.updatePins()
            }
        },
        methods: {
            updatePins() {
                var vm = this
                for (var i = 0; i < vm.mapPins.length; i++) {
                    vm.mapPins[i].setMap(null)
                }
                vm.mapPins = []
                var bounds = new google.maps.LatLngBounds()
                for (var i = 0; i < vm.pins.length; i++) {
                    var m = vm.createPin(vm.pins[i])
                    bounds.extend(m.position)
                    vm.mapPins.push(m)
                }
                if (vm.mapPins.length) vm.map.fitBounds(bounds)
            },
            createPin(p) {
                var vm = this
                var imgTag = p.Image == null ? '' : `<img srcset="${p.Image}" />`
                var content = `<div class="map-popup">${imgTag}<h4>${p.Name}</h4><p>${p.ShortDescription}</p><a href="${p.Url}" class="button">View</a></div>`
                var m = new google.maps.Marker({
                    position: new google.maps.LatLng(p.Point.Lat, p.Point.Lon),
                    icon: {
                        path: 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
                        fillColor: p.Color,
                        fillOpacity: 1,
                        anchor: new google.maps.Point(0, 0),
                        strokeWeight: 1,
                        strokeColor: vm.shadeColor(p.Color, 0.4),
                        scale: .5
                    },
                    title: p.Name,
                    content: content,
                    map: vm.map,
                })
                google.maps.event.addListener(m, 'click', function () {
                    vm.infoWindow.setContent(this.content)
                    vm.infoWindow.open(vm.map, this)
                })
                return m
            },
            shadeColor(color, percent) {
                var f = parseInt(color.slice(1), 16), t = percent < 0 ? 0 : 255, p = percent < 0 ? percent * -1 : percent, R = f >> 16, G = f >> 8 & 0x00FF, B = f & 0x0000FF;
                return "#" + (0x1000000 + (Math.round((t - R) * p) + R) * 0x10000 + (Math.round((t - G) * p) + G) * 0x100 + (Math.round((t - B) * p) + B)).toString(16).slice(1);
            }
        },
        mounted() {
            var position = new google.maps.LatLng(49.5799965, -2.3327157)
            this.map = new google.maps.Map(this.$el, {
                zoom: 10,
                maxZoom: 18,
                minZoom: 10,
                center: position,
                panControl: false,
                zoomControl: true,
                zoomControlOptions: {
                    position: google.maps.ControlPosition.LEFT_BOTTOM
                },
                fullscreenControl: false,
                draggable: true,
                scrollwheel: true,
                streetViewControl: false,
                mapTypeControl: false,
                gestureHandling: 'greedy',
                mapTypeId: google.maps.MapTypeId.ROADMAP
            })
            this.infoWindow = new google.maps.InfoWindow({
                content: '',
                maxWidth: 280,
                padding: '5px'
            })
            this.updatePins()
        }
    }
</script>